import "./contact.scss";
import { IoPersonOutline } from "react-icons/io5";
import { IoCallOutline } from "react-icons/io5";
import { MdOutlineMailOutline } from "react-icons/md";
import { FaRegMessage } from "react-icons/fa6";
import { PiBuildings } from "react-icons/pi";
import { FaWhatsapp } from "react-icons/fa";
import { MdOutlineMessage } from "react-icons/md";
import { MdOutlineAlternateEmail } from "react-icons/md";

import SectionHeader from "../../components/section_header/SectionHeader";
import { useState } from "react";
import { Bounce, toast, ToastContainer } from "react-toastify";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    number: "",
    subject: "Form is submitted from highqc.com",
    form_name: "HighQC Website Enquiry Form",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_key: "5f550cba-dfe3-4e64-b159-6774ed00b164",
          ...formData,
        }),
      });

      const result = await response.json();
      if (result.success) {
        toast.success("Form Submit Successful", {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        setFormData({ name: "", email: "", message: "", number: "" });
      } else {
        toast.error("Failed. Please try again later.", {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
      }
    } catch (error) {
      alert("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <div className="contact_main">
      <SectionHeader name={"Contact Us"} />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}
      />
      <div className="form_call_div">
        <div className="form_main">
          <div className="magicpattern"> </div>
          <div className="form_header">
            <h1>GET IN TOUCH</h1>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="input_div">
              <input
                type="hidden"
                name="subject"
                value="Form is submitted from highqc.com"
              />
              <input
                type="hidden"
                name="from_name"
                value="HighQC Website Enquiry Form"
              />
              <IoPersonOutline className="input_icon" />
              <input
                type="text"
                placeholder="Name"
                value={formData.name}
                name="name"
                onChange={handleChange}
                required
              />
            </div>
            <div className="input_div">
              <IoCallOutline className="input_icon" />
              <input
                type="text"
                placeholder="Number"
                name="number"
                value={formData.number}
                onChange={(e) => {
                  const input = e.target.value;
                  // Allow only digits and +
                  if (/^[0-9+]*$/.test(input)) {
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    });
                  }
                }}
              />
            </div>
            <div className="input_div">
              <MdOutlineMailOutline className="input_icon" />
              <input
                type="email"
                placeholder="Email"
                value={formData.email}
                name="email"
                onChange={handleChange}
                required
              />
            </div>
            <div className="input_div textarea_div">
              <FaRegMessage className="input_icon" />
              <textarea
                type="text"
                placeholder="Message"
                rows={5}
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>
            <div className="submit_button_div">
              <button className="button-50" type="submit">
                Let's Connect
              </button>
            </div>
          </form>
        </div>

        <div className="call_us_div">
          <h1>CALL US NOW</h1>
          <div className="call_us_card_div">
            <div className="call_us_map">
              <iframe
                title="Google Map of HIGHQ"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7213.064843642328!2d55.4585985!3d25.3199091!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5f26195b7e6b%3A0xc0f6d4eb509bdf75!2sSPC%20Free%20Zone%20-%20Business%20Setup%20In%20Sharjah%2C%20UAE!5e0!3m2!1sen!2sin!4v1750577425431!5m2!1sen!2sin"
                style={{ border: 0 }}
                loading="lazy"
              />
            </div>
            <div className="call_us_card">
              <div className="card_info">
                <PiBuildings className="card_icon icon_building" />
                <h4>
                  Al Zahia Area - Entrance No. 2 - Ground Floor - Sheikh
                  Mohammed Bin Zayed Rd - Sharjah - United Arab Emirates
                </h4>
              </div>
              <div className="card_info">
                <IoCallOutline className="card_icon " />

                <h4>+971 5540-96269</h4>
              </div>
              <div className="card_info">
                <MdOutlineMailOutline className="card_icon" />
                <h4>support@highqc.com</h4>
              </div>
              <div className="card_info">
                <FaWhatsapp className="card_icon" />

                <h4>+971 5540-96269</h4>
              </div>
              <hr />
              <div className="card_extra_div">
                <div className="card_name_icons">
                  <div className="card_name_indiv_icon">
                    <a href="tel:+9715540-96269" className="svg_icon">
                      <IoCallOutline className=" call_icon" />
                    </a>
                    <a
                      href="sms:+971554096269?body=Hi%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services."
                      className="svg_icon"
                    >
                      <MdOutlineMessage className=" message_icon" />
                    </a>
                    <a
                      href="https://wa.me/971554096269?text=Hi%2C%20I%20am%20interested%20in%20your%20services.%20Can%20we%20talk%3F"
                      target="_blank"
                      className="svg_icon"
                    >
                      <FaWhatsapp className=" whatsapp_icon" />
                    </a>
                    <a
                      href="mailto:consulting.highq@gmail.com?subject=Service%20Inquiry&body=Hi%2C%20I%20am%20interested%20in%20your%20services.%20Please%20let%20me%20know%20how%20to%20get%20started."
                      className="svg_icon"
                    >
                      <MdOutlineAlternateEmail className=" email_icon" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
